import * as React from 'react'
import { Modal } from 'antd'
import { FormattedMessage } from 'react-intl'
import { DeleteOutlined, ExclamationCircleOutlined } from '@ant-design/icons'
import ContributorButton from './ContributorButton'

type Props<T> = {
  item: T
  deleteItem: (_: T) => void
  loading: boolean
  children?: React.ReactNode
  title?: React.ReactNode
}

function ConfirmDeleteModal<T>({
  item,
  deleteItem,
  loading,
  children,
  title,
}: Props<T>) {
  const [visible, setVisible] = React.useState<boolean>(false)

  React.useEffect(() => {
    if (visible && !loading) {
      setVisible(false)
    }
  }, [loading])

  return (
    <>
      <ContributorButton
        icon={<DeleteOutlined />}
        loading={loading}
        onClick={() => setVisible(true)}
      />
      <Modal
        zIndex={3}
        visible={visible}
        cancelText={<FormattedMessage id="cancel" />}
        okText={<FormattedMessage id="confirm" />}
        onOk={() => deleteItem(item)}
        onCancel={() => setVisible(false)}
        confirmLoading={loading}
        title={
          <>
            <ExclamationCircleOutlined />
            {title}
          </>
        }
      >
        {children}
      </Modal>
    </>
  )
}

export default ConfirmDeleteModal
